// extracted by mini-css-extract-plugin
module.exports = {"back_button":"AuthPanel_back_button__1D0uD","auth_panel":"AuthPanel_auth_panel___TMiv"};